import OperationalReportsAPI from '../../api/operationalReports';

const state = () => ({
  dashboard: null,
  currentTeam: null,
  currentAgent: null,
  isLoading: false,
  hasError: false,
  activeFilters: { period: 'today' },
  exportJobs: {},
});

const getters = {
  kpis: s => s.dashboard?.kpis ?? {},
  teams: s => s.dashboard?.teams ?? [],
  charts: s => s.dashboard?.charts ?? {},
  costs: s => s.dashboard?.costs ?? {},
  isLoading: s => s.isLoading,
  hasError: s => s.hasError,
  currentTeam: s => s.currentTeam,
  currentAgent: s => s.currentAgent,
  activeFilters: s => s.activeFilters,
  exportJobs: s => s.exportJobs,
};

const mutations = {
  SET_LOADING(state, val) { state.isLoading = val; },
  SET_ERROR(state, val) { state.hasError = val; },
  SET_DASHBOARD(state, data) { state.dashboard = data; },
  UPDATE_DASHBOARD(state, data) {
    state.dashboard = { ...state.dashboard, ...data };
  },
  SET_CURRENT_TEAM(state, data) { state.currentTeam = data; },
  SET_CURRENT_AGENT(state, data) { state.currentAgent = data; },
  SET_FILTERS(state, filters) { state.activeFilters = { ...state.activeFilters, ...filters }; },
  SET_EXPORT_JOB(state, job) {
    state.exportJobs = { ...state.exportJobs, [job.job_id]: job };
  },
};

const actions = {
  async fetchDashboard({ commit, state }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', false);
    try {
      const { data } = await OperationalReportsAPI.getDashboard(state.activeFilters);
      commit('SET_DASHBOARD', data);
    } catch {
      commit('SET_ERROR', true);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchTeam({ commit, state }, teamId) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', false);
    try {
      const { data } = await OperationalReportsAPI.getTeam(teamId, state.activeFilters);
      commit('SET_CURRENT_TEAM', data);
    } catch {
      commit('SET_ERROR', true);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchAgent({ commit, state }, payload) {
    const agentId = typeof payload === 'object' ? payload.agentId : payload;
    const teamId  = typeof payload === 'object' ? payload.teamId  : null;
    const filters = teamId ? { ...state.activeFilters, team_id: teamId } : state.activeFilters;
    commit('SET_LOADING', true);
    commit('SET_ERROR', false);
    try {
      const { data } = await OperationalReportsAPI.getAgent(agentId, filters);
      commit('SET_CURRENT_AGENT', data);
    } catch {
      commit('SET_ERROR', true);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  setFilters({ commit, dispatch }, filters) {
    commit('SET_FILTERS', filters);
    dispatch('fetchDashboard');
  },

  setFiltersOnly({ commit }, filters) {
    commit('SET_FILTERS', filters);
  },

  async createExport({ commit }, payload) {
    const { data } = await OperationalReportsAPI.createExport(payload);
    commit('SET_EXPORT_JOB', data);
    return data.job_id;
  },

  async pollExport({ commit }, jobId) {
    const { data } = await OperationalReportsAPI.getExportStatus(jobId);
    commit('SET_EXPORT_JOB', data);
    return data;
  },

  applyWebSocketUpdate({ commit }, data) {
    commit('UPDATE_DASHBOARD', data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
